import { deleteBarrio, getBarriosPanel } from "../../services/BarriosServices";
import { BarriosContext } from "./BarriosContext"

export const BarriosState = ({ children }) => {

    const getBarriosPanelData = async (searchTerm,searchIDFilter,numpag, filas) => {
        let res = await getBarriosPanel(searchTerm,searchIDFilter , numpag, filas)
        return res
    }

    const deleteBarrioData = async (body,searchFilter,searchTerm, numpag, filas) => {
        const res = await deleteBarrio(body)
        if (res) getBarriosPanelData(searchFilter,searchTerm, numpag, filas)
        return res
    }

    return <BarriosContext.Provider value={{
        deleteBarrioData,
        getBarriosPanelData,
    }} >
        {children}
    </BarriosContext.Provider>
}
